module.exports = __webpack_public_path__ + "img/zy.842faf0c.png";